import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/swiper.min.css";
import "swiper/components/effect-coverflow/effect-coverflow.min.css"
import "swiper/components/pagination/pagination.min.css"
import './Blogs.css'
import extension from '../../images/extension.jpeg'
import reactComponent from '../../images/reactComponent.png'
import animationReact from '../../images/animationReact.jpg'
import js from '../../images/js.jpg'
import react from '../../images/react.png'
import js2 from '../../images/js2.png'
import es6 from '../../images/es6.jpg'
import SwiperCore, {
    EffectCoverflow, Pagination
} from 'swiper/core';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const blog1 = 'ashabhussan.medium.com/10-javascript-array-methods-you-should-know-e5ab62ca32cf'
const blog2 = 'ashabhussan.medium.com/fundamentals-of-es6-dc8e3a5a9eb7'
const blog3 = 'ashabhussan.medium.com/10-features-of-react-js-you-should-know-4dc816d1ff22'
const blog4 = 'ashabhussan.medium.com/10-tricky-javascript-question-7320581ba0ff'

SwiperCore.use([EffectCoverflow, Pagination]);

const Blogs = () => {
    return (
        <div>
            <h4 className='text-center mt-5' id='blog'>MY BLOGS</h4>
            <h2 className='text-center mb-5' id='writing'>Latest writings</h2>
            <div className='mb-5'>
                <Swiper effect={'coverflow'} grabCursor={true} centeredSlides={true} slidesPerView={'auto'}
                
                    coverflowEffect={{
                        "rotate": 50,
                        "stretch": 0,
                        "depth": 100,
                        "modifier": 1,
                        "slideShadows": true
                    }} pagination={true} className="mySwiper">

                    <SwiperSlide>
                        <img src={js} alt="" />
                        <h5>10 Javascript Array Methods You Should Know</h5>
                        <p>In this blog, we will explore the 10 most important Javascript Array Method. So without a very long intro, let's get started.</p>
                        <Link target='_blank' to={"//" + blog1} ><Button variant='info' >Read More</Button></Link>
                    </SwiperSlide>

                    <SwiperSlide>
                        <img src={es6} alt="" />
                        <h5>Fundamentals of ES6</h5>
                        <p>We know about Javascript, right? Javascript is a scripting or programming language that allows us to implement complex features on web pages.</p>
                        <Link target='_blank' to={"//" + blog2} ><Button variant='info' >Read More</Button></Link>
                    </SwiperSlide>

                    <SwiperSlide>
                        <img src={react} alt="" />
                        <h5>10 Features of React.js You Should Know</h5>
                        <p>React.js is the most popular Javascript library used in the field of web development. It is used by most popular companies like Facebook, Airbnb, Instagram, etc.</p>
                        <Link target='_blank' to={"//" + blog3} ><Button variant='info' >Read More</Button></Link>
                    </SwiperSlide>

                    <SwiperSlide>
                        <img src={js2} alt="" />
                        <h5>10 Tricky Javascript Question</h5>
                        <p>In this blog we will know about 10 tricky Javascript questions. So let's get started. </p>
                        <Link target='_blank' to={"//" + blog4} ><Button variant='info' >Read More</Button></Link>
                    </SwiperSlide>

                    {/* --------------------------- */}
                    <SwiperSlide>
                        <img src={js} alt="" />
                        <h5>10 Javascript Array Methods You Should Know</h5>
                        <p>In this blog, we will explore the 10 most important Javascript Array Method. So without a very long intro, let's get started.</p>
                        <Link target='_blank' to={"//" + blog1} ><Button variant='info' >Read More</Button></Link>
                    </SwiperSlide>

                    <SwiperSlide>
                        <img src={es6} alt="" />
                        <h5>Fundamentals of ES6</h5>
                        <p>We know about Javascript, right? Javascript is a scripting or programming language that allows us to implement complex features on web pages.</p>
                        <Link target='_blank' to={"//" + blog2} ><Button variant='info' >Read More</Button></Link>
                    </SwiperSlide>

                    <SwiperSlide>
                        <img src={react} alt="" />
                        <h5>10 Features of React.js You Should Know</h5>
                        <p>React.js is the most popular Javascript library used in the field of web development. It is used by most popular companies like Facebook, Airbnb, Instagram, etc.</p>
                        <Link target='_blank' to={"//" + blog3} ><Button variant='info' >Read More</Button></Link>
                    </SwiperSlide>

                    <SwiperSlide>
                        <img src={js2} alt="" />
                        <h5>10 Tricky Javascript Question</h5>
                        <p>In this blog we will know about 10 tricky Javascript questions. So let's get started. </p>
                        <Link target='_blank' to={"//" + blog4} ><Button variant='info' >Read More</Button></Link>
                    </SwiperSlide>
                    {/* --------------------------- */}

                </Swiper>


            </div>
        </div>
    );
};

export default Blogs;